/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharedplan_TitleInputs */

const en_us2_sharedplan_title = /** @type {(inputs: Sharedplan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shared plan`)
};

const pt_br2_sharedplan_title = /** @type {(inputs: Sharedplan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano compartilhado`)
};

const pt_pt2_sharedplan_title = /** @type {(inputs: Sharedplan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano compartilhado`)
};

/** @type {(inputs: Sharedplan_TitleInputs) => LocalizedString} */
const es_419_sharedplan_title = en_us2_sharedplan_title;

/** @type {(inputs: Sharedplan_TitleInputs) => LocalizedString} */
const fr_fr2_sharedplan_title = en_us2_sharedplan_title;

/** @type {(inputs: Sharedplan_TitleInputs) => LocalizedString} */
const de_de2_sharedplan_title = en_us2_sharedplan_title;

/** @type {(inputs: Sharedplan_TitleInputs) => LocalizedString} */
const it_it2_sharedplan_title = en_us2_sharedplan_title;

/**
* | output |
* | --- |
* | "Shared plan" |
*
* @param {Sharedplan_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const sharedplan_title = /** @type {((inputs?: Sharedplan_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharedplan_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_sharedplan_title(inputs)
	if (locale === "es-419") return es_419_sharedplan_title(inputs)
	if (locale === "pt-PT") return pt_pt2_sharedplan_title(inputs)
	if (locale === "fr-FR") return fr_fr2_sharedplan_title(inputs)
	if (locale === "de-DE") return de_de2_sharedplan_title(inputs)
	if (locale === "it-IT") return it_it2_sharedplan_title(inputs)
	return en_us2_sharedplan_title(inputs)
});
export { sharedplan_title as "sharedplan.title" }